import {createReducer} from "redux-act";
import {fetchMessageSuccess, hideBanner, IBanner, showBanner} from "modules/actions";

interface IMessagesReducer {
	text?: string;
	banner: IBanner | null;
}

const initialState: IMessagesReducer = {
	banner: null,
};

const onShowBanner = (state: IMessagesReducer, banner: IBanner) => ({
	...state,
	banner,
});

const onHideBanner = (state: IMessagesReducer) => ({
	...state,
	banner: null,
});

export const messages = createReducer<IMessagesReducer>({}, initialState)
	.on(fetchMessageSuccess, (state, {text}) => ({...state, text}))
	.on(showBanner, onShowBanner)
	.on(hideBanner, onHideBanner);
